import React, { useEffect } from "react";
import { helmetJsonLdProp } from "react-schemaorg";
import Helmet from "react-helmet";
import { Container, Row, Col } from "react-bootstrap/esm/index";
import { Link } from "react-router-dom";

// Import Components
import ItpNavigation from "../../components/ITPNavigation/ITPNavigation";
import HalfTextHalfImageHero from "../../components/HeroHeader/HalfTextHalfImageHero";
import FooterITP from "../../components/shared-ui/Footer/Footer-ITP";
import BackToTopBtn from "../../components/shared-ui/BackToTopBtn/BackToTopBtn";
import ISIITPinline from "../../components/shared-ui/ISI/ISIITP-inline";
import ISIwrapper from "../../components/shared-ui/ISI/ISI-wrapper";
import ISIITP from "../../components/shared-ui/ISI/ISIITP";
import PrimaryButton from "../../components/shared-ui/Buttons/PrimaryButton";
import { pushOutboundClickFacebookHeader } from "../../assets/datalayerFunctions";

// Import Styles
import "../../css/ThankYou.scss";

function showModal(url) {
  let modal = document.querySelector("#modal");
  document.body.classList.add("no-scroll");
  modal.classList.remove("fadeOut");
  modal.style.display = "block";
  modal.classList.add("fadeIn");
  modal.style.height = "100%";
  modal.children[0].children[1].children[3].href = url;
  modal.children[0].children[1].children[3].target = "_blank";
  modal.children[0].children[1].children[3].addEventListener(
    "click",
    function() {
      modal.style.display = "none";
    }
  );
}

function addModalLinksFacebookHeader(event) {
  pushOutboundClickFacebookHeader(event);
  event.preventDefault();
  let url = event.currentTarget.href;
  let title = event.target.title;
  showModal(url, title);
};

function ThankYou() {
  useEffect(() => {
    window.scrollTo(0, 0);
    let location = window.location.pathname;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      page: {
        path: `${location}`,
        title: "Thank You | DOPTELET® (avatrombopag)",
        environment: "dev",
        indication: "ITP",
        audience: "DTC",
      },
    });
  }, []);
  return (
    <div className="main_content_wrap">
      <Helmet
        script={[
          helmetJsonLdProp({
            "@context": "https://schema.org",
            "@graph": [
              {
                "@type": "Drug",
                name: "Doptelet",
                alternateName: "avatrombopag",
                manufacturer: {
                  "@type": "Organization",
                  name: "Sobi",
                },
                dosageForm: "Pill",
              },
              {
                "@type": "WebSite",
                about: {
                  "@type": "Thing",
                  description:
                    "To inform patients of Doptelet (avatrombopag), a prescription medicine used to treat low blood platelet counts in adults with chronic immune thrombocytopenia when other treatments have not worked well enough. Doptelet (avatrombopag) is also a prescription medicine used to treat low blood platelet counts in adults with long-lasting (chronic) liver disease who are scheduled to have a medical or dental procedure.",
                },
                url: "https://doptelethcp.com/itp/thank-you/",
              },
              {
                "@type": "Brand",
                logo: "https://doptelet.com/images/doptelet-avatrombopag-tablets-logo.svg",
              },
              {
                "@type": "Brand",
                logo: "https://doptelet.com/images/sobi-logo.png",
              },
              {
                "@type": "MedicalAudience",
                audienceType:
                  "Patients with chronic immune thrombocytopenia when other treatments have not worked well enough. ",
                healthCondition: {
                  "@type": "MedicalCondition",
                  alternateName: "Immune Thrombocytopenia (ITP)",
                },
                requiredMinAge: "18",
              },
              {
                "@type": "HealthTopicContent",
                hasHealthAspect:
                  "The most common side effects of DOPTELET when used to treat low blood platelet counts in adults with chronic immune thrombocytopenia (ITP) are: headache, tiredness, bruising, nosebleed, upper-respiratory tract infection, joint pain, gum bleeding, purple or red spots on your skin, runny nose",
              },
            ],
          }),
        ]}
      >

        <meta name="robots" content="noindex" />

      </Helmet>
      <ItpNavigation />
      <div className="inner-content-wrap">
        <HalfTextHalfImageHero
          markup={
            <>
              <h1>Get Tips for Living With ITP</h1>
              <p>Sign up for tools and tips to help you manage your chronic ITP, set treatment goals, and have more productive doctor’s visits—plus a few other surprises!</p>
            </>
          }
          image={['welcome-kit-image.png']}
          imageAlt="Doptelet Platelet Character Eating Two Ice Cream Cones"
          extraClass="faq-banner"
        />

        <section className="section-padding">
          <Container>
            <Row>
              <Col>
                <h2 className="text-left text-md-center">NICE!</h2>
                <p className="text-left text-md-center">You’ve successfully signed up—look out for chronic ITP tools and tips flowing your way!</p>
                <img src="/images/platey-couple.png" alt="A couple of plateys walking" className="d-block m-auto img-responsive" style={{maxWidth: 410}} />
                <hr className="navy-bg mt-4 mb-4" />
                <h2 className="text-left text-md-center mb-4">KEEP LEARNING</h2>
              </Col>
            </Row>
            <Row>
              <Col md={3}></Col>
              <Col md={3} className="mb-4">
                <PrimaryButton
                  title="About Doptelet"
                  href="/what-is-doptelet/"
                  addClass="btn-arrow align-self-start"
                />
              </Col>
              <Col md={3} className="mb-4">
                <PrimaryButton
                  title="MORE ITP RESOURCES"
                  href="/support-and-resources/"
                  addClass="btn-arrow align-self-start"
                />
              </Col>
              <Col md={3}></Col>
            </Row>
            <Row>
              <Col>
                <ul className="social-list mt-3">
                  <li className="social-link">
                    <Link
                      to={{ pathname: "https://www.facebook.com/doptelet/" }}
                      className="utility-social-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={addModalLinksFacebookHeader}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <title>Doptelet Blue FaceBook Icon</title>
                        <path id="Facebook" d="M890.6,15.775A12,12,0,1,0,876.734,27.7V19.256h-3.065V15.775h3.065V13.113c0-3.022,1.78-4.7,4.523-4.7a17.122,17.122,0,0,1,2.669.249v2.947h-1.508a1.752,1.752,0,0,0-1.965,1.89v2.263h3.337l-.531,3.482h-2.805v8.444A12.017,12.017,0,0,0,890.6,15.775Z" transform="translate(-866.6 -3.7)" fill="#1B4677" />
                      </svg>
                    </Link>
                  </li>
                  <li className="social-link">
                    <Link
                      to={{ pathname: "https://www.youtube.com/@dopteletavatrombopag5013" }}
                      className="utility-social-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={addModalLinksFacebookHeader}
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="19.6" viewBox="0 0 28 19.6">
                        <title>Doptelet Blue YouTube Icon</title>
                        <g id="YouTube" transform="translate(-369 -803)">
                          <path id="Path_199" data-name="Path 199" d="M27.415,3.06A3.507,3.507,0,0,0,24.939.585C22.756,0,14,0,14,0S5.244,0,3.06.585A3.507,3.507,0,0,0,.585,3.06,36.427,36.427,0,0,0,0,9.8a36.429,36.429,0,0,0,.585,6.739A3.506,3.506,0,0,0,3.06,19.015C5.244,19.6,14,19.6,14,19.6s8.756,0,10.939-.585a3.506,3.506,0,0,0,2.476-2.475A36.43,36.43,0,0,0,28,9.8a36.427,36.427,0,0,0-.585-6.739" transform="translate(369 803)" fill="#1B4677" />
                          <path id="Path_200" data-name="Path 200" d="M27.213,22.007v-8.4l7.274,4.2Z" transform="translate(352.988 794.994)" fill="white" />
                        </g>
                      </svg>
                    </Link>
                  </li>
                  <li className="social-link">
                    <Link
                      to={{ pathname: "https://www.instagram.com/doptelet_avatrombopag" }}
                      className="utility-social-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={addModalLinksFacebookHeader}
                    >
                      <svg id="Instagram" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                        <title>Doptelet Blue Instagram Icon</title>
                        <path id="Path_196" data-name="Path 196" d="M12,2.162c3.2,0,3.584.012,4.849.07a6.665,6.665,0,0,1,2.228.413,3.724,3.724,0,0,1,1.38.9,3.724,3.724,0,0,1,.9,1.38,6.639,6.639,0,0,1,.413,2.228c.058,1.265.07,1.645.07,4.849s-.012,3.584-.07,4.849a6.639,6.639,0,0,1-.413,2.228,3.977,3.977,0,0,1-2.278,2.278,6.639,6.639,0,0,1-2.228.413c-1.265.058-1.645.07-4.849.07s-3.584-.012-4.849-.07a6.639,6.639,0,0,1-2.228-.413,3.724,3.724,0,0,1-1.38-.9,3.724,3.724,0,0,1-.9-1.38,6.665,6.665,0,0,1-.413-2.228c-.058-1.265-.07-1.645-.07-4.849s.012-3.584.07-4.849a6.665,6.665,0,0,1,.413-2.228,3.724,3.724,0,0,1,.9-1.38,3.724,3.724,0,0,1,1.38-.9,6.665,6.665,0,0,1,2.228-.413C8.416,2.174,8.8,2.162,12,2.162M12,0C8.741,0,8.332.014,7.052.072A8.785,8.785,0,0,0,4.14.63,5.881,5.881,0,0,0,2.014,2.014,5.881,5.881,0,0,0,.63,4.14,8.785,8.785,0,0,0,.072,7.052C.014,8.332,0,8.741,0,12s.014,3.668.072,4.948A8.785,8.785,0,0,0,.63,19.86a5.881,5.881,0,0,0,1.384,2.126A5.881,5.881,0,0,0,4.14,23.37a8.785,8.785,0,0,0,2.912.558C8.332,23.986,8.741,24,12,24s3.668-.014,4.948-.072a8.785,8.785,0,0,0,2.912-.558,6.133,6.133,0,0,0,3.51-3.51,8.785,8.785,0,0,0,.558-2.912C23.986,15.668,24,15.259,24,12s-.014-3.668-.072-4.948A8.785,8.785,0,0,0,23.37,4.14a5.881,5.881,0,0,0-1.384-2.126A5.881,5.881,0,0,0,19.86.63,8.785,8.785,0,0,0,16.948.072C15.668.014,15.259,0,12,0" fill="#1B4677" />
                        <path id="Path_197" data-name="Path 197" d="M12,5.838A6.162,6.162,0,1,0,18.162,12,6.162,6.162,0,0,0,12,5.838M12,16a4,4,0,1,1,4-4,4,4,0,0,1-4,4" fill="#1B4677" />
                        <path id="Path_198" data-name="Path 198" d="M19.846,5.594a1.44,1.44,0,1,1-1.44-1.44,1.44,1.44,0,0,1,1.44,1.44" fill="#1B4677" />
                      </svg>
                    </Link>
                  </li>
                </ul>
              </Col>
            </Row>
          </Container>
        </section>

        <ISIITPinline />
      </div>
      <FooterITP />
      <ISIwrapper>
        <ISIITP />
      </ISIwrapper>
      <BackToTopBtn />
    </div>
  );
}

export default ThankYou;
